import Vue from 'vue';
import { 
	Button,
	Row,
	Col,
	Menu,
	Submenu,
	MenuItem,
	MenuItemGroup,
	Table,
	TableColumn,
	Pagination,
	Form,
	FormItem,
	Input,
	Message,
	Dialog,
	Loading,
	MessageBox,
	InputNumber
} from 'element-ui';

Vue.use(Button);
Vue.use(Row);
Vue.use(Col);
Vue.use(Menu);
Vue.use(Submenu);
Vue.use(MenuItem);
Vue.use(MenuItemGroup);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Pagination);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Input);
Vue.use(Dialog);
Vue.use(Loading);
Vue.use(InputNumber);
// 此处使用message不能use，否则会自动弹出
Vue.prototype.$message = Message;
Vue.prototype.$confirm = MessageBox.confirm;

